module.exports = __webpack_public_path__ + "images/account_setups/icon-project-kanban-view-5db9912ad9b030ce9705ae1cf643c1df.png";